import { Components, CssVarsTheme, Theme } from "@mui/material";

const Switch = () // theme: Theme
: Components<Omit<Theme, "components" | "palette"> & CssVarsTheme> => ({
  MuiSwitch: {},
});

export default Switch;
